/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type Chat_Viewer = {
    readonly " $fragmentRefs": FragmentRefs<"InfiniteScrollMessages_Viewer">;
    readonly " $refType": "Chat_Viewer";
};
export type Chat_Viewer$data = Chat_Viewer;
export type Chat_Viewer$key = {
    readonly " $data"?: Chat_Viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"Chat_Viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Chat_Viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InfiniteScrollMessages_Viewer"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'a93293431ddd6dbace626f70340cc4e5';
export default node;
